var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "dashboard-panel tech-dashboard" }, [
                _c("div", { staticClass: "dashboard-cards" }, [
                  _c(
                    "div",
                    { staticClass: "dashboard-card tech-card tech-card-total" },
                    [
                      _c("div", { staticClass: "dashboard-card-title" }, [
                        _vm._v("成交总计"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.dashboardLoading.totalDeal,
                              expression: "dashboardLoading.totalDeal",
                            },
                          ],
                          staticClass: "dashboard-card-value",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatDashboardNum(
                                  _vm.displaySummary.totalDeal
                                )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dashboard-card tech-card tech-card-fudou" },
                    [
                      _c("div", { staticClass: "dashboard-card-title" }, [
                        _c(
                          "span",
                          {
                            staticClass: "dashboard-icon-fudou",
                            attrs: { title: "福豆" },
                          },
                          [_vm._v("🫘")]
                        ),
                        _vm._v(" 福豆成交总计\n              "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.dashboardLoading.fudouDealTotal,
                              expression: "dashboardLoading.fudouDealTotal",
                            },
                          ],
                          staticClass: "dashboard-card-value",
                        },
                        [
                          _c("span", { staticClass: "dashboard-icon-fudou" }, [
                            _vm._v("🫘"),
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatDashboardNum(
                                  _vm.displaySummary.fudouDealTotal
                                )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dashboard-card tech-card tech-card-third" },
                    [
                      _c("div", { staticClass: "dashboard-card-title" }, [
                        _vm._v("三方支付成交总计"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.dashboardLoading.thirdPartyDealTotal,
                              expression:
                                "dashboardLoading.thirdPartyDealTotal",
                            },
                          ],
                          staticClass: "dashboard-card-value",
                        },
                        [
                          _c("span", { staticClass: "dashboard-icon-yen" }, [
                            _vm._v("¥"),
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatDashboardNum(
                                  _vm.displaySummary.thirdPartyDealTotal
                                )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dashboard-card tech-card tech-card-supply",
                    },
                    [
                      _c("div", { staticClass: "dashboard-card-title" }, [
                        _vm._v("供货价总计"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.dashboardLoading.supplyPriceTotal,
                              expression: "dashboardLoading.supplyPriceTotal",
                            },
                          ],
                          staticClass: "dashboard-card-value",
                        },
                        [
                          _c("span", { staticClass: "dashboard-icon-yen" }, [
                            _vm._v("¥"),
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatDashboardNum(
                                  _vm.displaySummary.supplyPriceTotal
                                )
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dashboard-card tech-card tech-card-marketing",
                    },
                    [
                      _c("div", { staticClass: "dashboard-card-title" }, [
                        _c("span", [_vm._v("营销汇总")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "marketing-toggle",
                            on: {
                              click: function ($event) {
                                _vm.marketingExpanded = !_vm.marketingExpanded
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.marketingExpanded
                                    ? "收起明细"
                                    : "查看明细"
                                ) +
                                "\n                  "
                            ),
                            _c("i", {
                              class: _vm.marketingExpanded
                                ? "el-icon-arrow-up"
                                : "el-icon-arrow-down",
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.marketingLoading,
                              expression: "marketingLoading",
                            },
                          ],
                          staticClass: "dashboard-card-value",
                        },
                        [
                          _c("span", { staticClass: "dashboard-icon-yen" }, [
                            _vm._v("¥"),
                          ]),
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatDashboardNum(_vm.marketingTotal)
                              ) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.marketingExpanded,
                              expression: "marketingExpanded",
                            },
                          ],
                          staticClass: "marketing-detail",
                        },
                        [
                          _c("div", { staticClass: "marketing-detail-item" }, [
                            _c(
                              "span",
                              { staticClass: "marketing-detail-label" },
                              [_vm._v("优惠券优惠：")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "marketing-detail-value" },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatDashboardNum(
                                        _vm.displaySummary.couponPriceTotal
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "marketing-detail-item" }, [
                            _c(
                              "span",
                              { staticClass: "marketing-detail-label" },
                              [_vm._v("立减活动优惠：")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "marketing-detail-value" },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatDashboardNum(
                                        _vm.displaySummary.totalInstantDiscount
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "marketing-detail-item" }, [
                            _c(
                              "span",
                              { staticClass: "marketing-detail-label" },
                              [_vm._v("加油立减优惠：")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "marketing-detail-value" },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatDashboardNum(
                                        _vm.displaySummary.immediatePriceTotal
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "marketing-detail-item" }, [
                            _c(
                              "span",
                              { staticClass: "marketing-detail-label" },
                              [_vm._v("活动福利立减金额：")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "marketing-detail-value" },
                              [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatDashboardNum(
                                        _vm.displaySummary
                                          .activityLuckyPromoPric
                                      )
                                    )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入订单编号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderNo", $$v)
                                },
                                expression: "listPram.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "微信订单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入微信订单号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.outOrderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "outOrderNo", $$v)
                                },
                                expression: "listPram.outOrderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收件人名" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.receiverName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "receiverName", $$v)
                                },
                                expression: "listPram.receiverName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收件电话" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.receiverPhone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "receiverPhone", $$v)
                                },
                                expression: "listPram.receiverPhone",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth",
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              size: "small",
                              "picker-options": _vm.datePickerOptions,
                            },
                            on: { change: _vm.handleDateRangeChange },
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                multiple: "",
                                placeholder: "请选择",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "status", $$v)
                                },
                                expression: "listPram.status",
                              },
                            },
                            _vm._l(_vm.orderStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "下单人手机号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入下单人手机号",
                                size: "small",
                                clearable: "",
                                maxlength: "11",
                              },
                              model: {
                                value: _vm.listPram.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "phone", $$v)
                                },
                                expression: "listPram.phone",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "收款商户号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入微信商户号",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.merchantNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "merchantNo", $$v)
                                },
                                expression: "listPram.merchantNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isFormVisible,
                      expression: "isFormVisible",
                    },
                  ],
                  staticClass: "container",
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props,
                              clearable: "",
                              size: "small",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.handerSearch(0)
                              },
                            },
                            model: {
                              value: _vm.listPram.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "categoryId", $$v)
                              },
                              expression: "listPram.categoryId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleAgreementSearch,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "brandId", $$v)
                                },
                                expression: "listPram.brandId",
                              },
                            },
                            _vm._l(_vm.brandOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.brandStr, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleSupplierSearch,
                              },
                              on: {
                                change: _vm.handleSupplierChange,
                                "visible-change": function ($event) {
                                  $event && _vm.searchSupplier()
                                },
                              },
                              model: {
                                value: _vm.listPram.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "supplierId", $$v)
                                },
                                expression: "listPram.supplierId",
                              },
                            },
                            _vm._l(_vm.supplierOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.supplierName || item.merchantName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店筛选" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                clearable: "",
                                filterable: "",
                                disabled:
                                  !_vm.listPram.supplierId ||
                                  ![11, 100, 101, 102].includes(
                                    Number(_vm.listPram.orderType)
                                  ),
                                placeholder: "请选择线下核销和多商户订单类型",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.storeId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "storeId", $$v)
                                },
                                expression: "listPram.storeId",
                              },
                            },
                            _vm._l(_vm.storeOptions, function (item) {
                              return _c("el-option", {
                                key: item.storeId,
                                attrs: {
                                  label: item.storeName,
                                  value: item.storeId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单标签" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.tagId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "tagId", $$v)
                                },
                                expression: "listPram.tagId",
                              },
                            },
                            _vm._l(_vm.selectTagList, function (item) {
                              return _c("el-option", {
                                key: item.tagId,
                                attrs: {
                                  label: item.tagName,
                                  value: item.tagId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKU编码" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入SKU编码",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.skuCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "skuCode", $$v)
                                },
                                expression: "listPram.skuCode",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SPU名称" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请输入SPU名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.spuName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "spuName", $$v)
                                },
                                expression: "listPram.spuName",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handleOrderTypeChange },
                              model: {
                                value: _vm.listPram.orderType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderType", $$v)
                                },
                                expression: "listPram.orderType",
                              },
                            },
                            _vm._l(_vm.orderTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      Number(_vm.listPram.orderType) === 18
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "一卡通类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handerSearch(0)
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.card_type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "card_type", $$v)
                                    },
                                    expression: "listPram.card_type",
                                  },
                                },
                                _vm._l(_vm.oneCardTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "一卡通预约订单" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.oneCardOrderFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listPram,
                                    "oneCardOrderFlag",
                                    $$v
                                  )
                                },
                                expression: "listPram.oneCardOrderFlag",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "否", value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showMerchantStoreTypeFilter
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "店铺类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handerSearch(0)
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.storeType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "storeType", $$v)
                                    },
                                    expression: "listPram.storeType",
                                  },
                                },
                                _vm._l(_vm.storeTypeOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "积分订单类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.integralOrderType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.listPram,
                                    "integralOrderType",
                                    $$v
                                  )
                                },
                                expression: "listPram.integralOrderType",
                              },
                            },
                            _vm._l(
                              _vm.integralOrderTypeOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.listPram.orderType == 7
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "拼团状态" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handerSearch(0)
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.pinkStatus,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "pinkStatus", $$v)
                                    },
                                    expression: "listPram.pinkStatus",
                                  },
                                },
                                _vm._l(_vm.pintuanOrderStates, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userType == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "销售渠道" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请输入选择",
                                    clearable: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handerSearch(0)
                                    },
                                  },
                                  model: {
                                    value: _vm.listPram.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "customerId", $$v)
                                    },
                                    expression: "listPram.customerId",
                                  },
                                },
                                _vm._l(_vm.customers, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userType == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "归属项目" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择",
                                    filterable: "",
                                    remote: "",
                                    "remote-method":
                                      _vm.customrOrderRemoteMethod,
                                    size: "small",
                                    clearable: "",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.listPram.customOrderId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.listPram,
                                        "customOrderId",
                                        $$v
                                      )
                                    },
                                    expression: "listPram.customOrderId",
                                  },
                                },
                                _vm._l(_vm.customerOrderList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.orderName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("el-button", {
                                staticClass: "search-button",
                                attrs: {
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handerSearch(0)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "福卡名" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                clearable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handerSearch(0)
                                },
                              },
                              model: {
                                value: _vm.listPram.cardId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "cardId", $$v)
                                },
                                expression: "listPram.cardId",
                              },
                            },
                            _vm._l(_vm.fuCardOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.cardName, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-center" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:enhanced:download"],
                          expression: "['admin:order:enhanced:download']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportFastOrderList },
                    },
                    [_vm._v("订单导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:download"],
                          expression: "['admin:order:download']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportList },
                    },
                    [_vm._v("结果导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:export:item"],
                          expression: "['admin:order:export:item']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportOrderSendList },
                    },
                    [_vm._v("订单发货导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:export:item"],
                          expression: "['admin:order:export:item']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportOrderSendListSplit },
                    },
                    [_vm._v("订单发货导出（拆分）")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:import"],
                          expression: "['admin:order:import']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.doImport },
                    },
                    [_vm._v("批量导入发货")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:import"],
                          expression: "['admin:order:import']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.doImportFudouStatus },
                    },
                    [_vm._v("福豆充值状态变更导入")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "has-permi",
                          rawName: "v-has-permi",
                          value: ["admin:order:finance:import"],
                          expression: "['admin:order:finance:import']",
                        },
                      ],
                      staticClass: "mr20",
                      attrs: { type: "primary" },
                      on: { click: _vm.exportFinanceList },
                    },
                    [_vm._v("财务导出")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr20",
                      attrs: { type: "info", icon: "el-icon-document" },
                      on: { click: _vm.goToDownloadTask },
                    },
                    [_vm._v("\n            导出任务\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      staticClass: "dashboard-detail-dialog",
                      attrs: {
                        title: "福豆使用详情",
                        visible: _vm.fudouDetailVisible,
                        width: "720px",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.fudouDetailVisible = $event
                        },
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.fudouDetailList,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "cardTypeName",
                              label: "福卡",
                              "min-width": "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "dealTotal",
                              label: "成交总福豆",
                              "min-width": "140",
                              align: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(scope.row.dealTotal)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "refundTotal",
                              label: "退款总福豆",
                              "min-width": "140",
                              align: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(scope.row.refundTotal)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      staticClass: "dashboard-detail-dialog",
                      attrs: {
                        title: "第三方支付详情",
                        visible: _vm.thirdPartyDetailVisible,
                        width: "640px",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.thirdPartyDetailVisible = $event
                        },
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.thirdPartyDetailList,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "channelName",
                              label: "支付渠道",
                              "min-width": "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "dealTotal",
                              label: "成交总金额",
                              "min-width": "140",
                              align: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(scope.row.dealTotal)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "refundTotal",
                              label: "退款总金额",
                              "min-width": "140",
                              align: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMoney(scope.row.refundTotal)
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      staticClass: "download-task-dialog",
                      attrs: {
                        title: "导出任务管理",
                        visible: _vm.downloadTaskDialogVisible,
                        width: "90%",
                        "close-on-click-modal": false,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.downloadTaskDialogVisible = $event
                        },
                      },
                    },
                    [
                      _vm.downloadTaskDialogVisible
                        ? _c("download-task")
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "选择导出方式",
                        visible: _vm.exportMergeCellDialogVisible,
                        width: "620px",
                        "close-on-click-modal": false,
                        "custom-class": "export-dialog",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.exportMergeCellDialogVisible = $event
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "export-mode-dialog-content" }, [
                        _c("div", { staticClass: "export-mode-options" }, [
                          _c(
                            "div",
                            {
                              staticClass: "export-mode-card",
                              class: {
                                "is-selected": _vm.exportMergeCell === true,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.exportMergeCell = true
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "mode-card-left" }, [
                                _c(
                                  "div",
                                  { staticClass: "mode-card-icon merge-icon" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cell-merge-visual" },
                                      [
                                        _c("div", { staticClass: "cm-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cm-cell cm-merged",
                                            },
                                            [_c("span", [_vm._v("商品A")])]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "cm-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cm-cell cm-merged",
                                            },
                                            [_c("span")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "cm-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "cm-cell cm-merged",
                                            },
                                            [_c("span")]
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mode-card-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "mode-card-title" },
                                    [_vm._v("合并单元格")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mode-card-desc" }, [
                                    _vm._v("同一订单的多行商品合并显示"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mode-card-tag" }, [
                                    _vm._v("适合查看整理"),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mode-card-check" }, [
                                _vm.exportMergeCell === true
                                  ? _c("i", { staticClass: "el-icon-check" })
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.supportNoMerge
                            ? _c(
                                "div",
                                {
                                  staticClass: "export-mode-card",
                                  class: {
                                    "is-selected":
                                      _vm.exportMergeCell === false,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportMergeCell = false
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "mode-card-left" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mode-card-icon no-merge-icon",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cell-split-visual" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "cs-cell" },
                                              [_c("span", [_vm._v("商品A")])]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "cs-cell" },
                                              [_c("span", [_vm._v("商品B")])]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "cs-cell" },
                                              [_c("span", [_vm._v("商品C")])]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mode-card-info" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "mode-card-title" },
                                          [_vm._v("不合并单元格")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mode-card-desc" },
                                          [_vm._v("同一订单的多行商品各自独立")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-card-tag tag-blue",
                                          },
                                          [_vm._v("适合数据筛选统计")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mode-card-check" },
                                    [
                                      _vm.exportMergeCell === false
                                        ? _c("i", {
                                            staticClass: "el-icon-check",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "export-mode-preview" }, [
                          _c("div", { staticClass: "preview-header" }, [
                            _c("div", { staticClass: "preview-dots" }, [
                              _c("span", { staticClass: "dot dot-red" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "dot dot-yellow" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "dot dot-green" }),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "preview-title" }, [
                              _vm._v("Excel 预览"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.exportMergeCell === true
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "preview-table preview-merged-table",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "preview-row header-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "preview-cell col-order",
                                        },
                                        [_vm._v("订单号")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "preview-cell col-product",
                                        },
                                        [_vm._v("商品")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "preview-cell col-price",
                                        },
                                        [_vm._v("金额")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-row-group" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "preview-row" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "preview-cell col-order",
                                              staticStyle: {
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cell-merge-cover merged-row1",
                                                },
                                                [_vm._v("ORD-001")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "preview-cell col-product",
                                              staticStyle: {
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cell-merge-cover merged-row1",
                                                },
                                                [_vm._v("iPhone 手机")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "preview-cell col-price",
                                              staticStyle: {
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cell-merge-cover merged-row1",
                                                },
                                                [_vm._v("¥5999")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "preview-row" },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "preview-cell col-order",
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "preview-cell col-product",
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "preview-cell col-price",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "preview-row" },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "preview-cell col-order",
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "preview-cell col-product",
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass:
                                              "preview-cell col-price",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _c("div", { staticClass: "preview-table" }, [
                                _c(
                                  "div",
                                  { staticClass: "preview-row header-row" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "preview-cell col-order" },
                                      [_vm._v("订单号")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "preview-cell col-product",
                                      },
                                      [_vm._v("商品")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "preview-cell col-price" },
                                      [_vm._v("金额")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "preview-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-order" },
                                    [_vm._v("ORD-001")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-product" },
                                    [_vm._v("iPhone 手机")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-price" },
                                    [_vm._v("¥5999")]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "preview-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-order" },
                                    [_vm._v("ORD-001")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-product" },
                                    [_vm._v("AirPods 耳机")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-price" },
                                    [_vm._v("¥1999")]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "preview-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-order" },
                                    [_vm._v("ORD-001")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-product" },
                                    [_vm._v("Watch 手表")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "preview-cell col-price" },
                                    [_vm._v("¥2999")]
                                  ),
                                ]),
                              ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "preview-hint" }, [
                            _c("i", { staticClass: "el-icon-info" }),
                            _vm._v(" "),
                            _vm.exportMergeCell === true
                              ? _c("span", [
                                  _vm._v("订单号、商品、金额仅首行显示"),
                                ])
                              : _c("span", [
                                  _vm._v("每个商品独立一行，可筛选统计"),
                                ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer",
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.exportMergeCellDialogVisible = false
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.confirmExportFastOrder },
                            },
                            [_vm._v("确认导出")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.isExporting,
                        title: _vm.exportDialogTitle,
                        "show-close": true,
                        "close-on-click-modal": true,
                        "before-close": _vm.handleExportDialogClose,
                        "custom-class": "export-dialog",
                        width: "500px",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.isExporting = $event
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "export-dialog-content" }, [
                        _vm.isInQueue
                          ? _c("div", { staticClass: "queue-mode" }, [
                              _c("div", { staticClass: "queue-icon-wrapper" }, [
                                _c("i", {
                                  staticClass: "el-icon-refresh queue-icon",
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "h3",
                                { staticClass: "export-title queue-title" },
                                [_vm._v("您已进入排队队列")]
                              ),
                              _vm._v(" "),
                              _vm.currentQueuePosition > 0
                                ? _c("div", { staticClass: "queue-position" }, [
                                    _vm._v(
                                      "\n                  当前排队位置：第 "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "queue-number" },
                                      [_vm._v(_vm._s(_vm.currentQueuePosition))]
                                    ),
                                    _vm._v(" 位\n                "),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.queueDetail
                                ? _c(
                                    "div",
                                    { staticClass: "queue-detail-info" },
                                    [
                                      _vm.queueDetail.processingTask
                                        ? _c(
                                            "div",
                                            { staticClass: "detail-row" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "detail-label" },
                                                [_vm._v("正在执行：")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "detail-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.queueDetail
                                                        .processingTask
                                                        .taskTypeName
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.queueDetail.processingTask
                                                .userName
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "detail-owner",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-user",
                                                      }),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.queueDetail
                                                            .processingTask
                                                            .userName
                                                        ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.queueDetail.processingTask
                                                .progress
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "detail-progress",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.queueDetail
                                                              .processingTask
                                                              .progress
                                                          ) +
                                                          "%\n                    "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.queueDetail.waitingCount > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "detail-row" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "detail-label" },
                                                [_vm._v("排队中：")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "detail-value" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.queueDetail
                                                        .waitingCount
                                                    ) + " 个任务"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.queueDetail.processingTask &&
                                      _vm.queueDetail.processingTask
                                        .estimatedRemainingSeconds
                                        ? _c(
                                            "div",
                                            { staticClass: "detail-row" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "detail-label" },
                                                [_vm._v("预计剩余：")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "detail-value detail-time",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatWaitTime(
                                                        _vm.queueDetail
                                                          .processingTask
                                                          .estimatedRemainingSeconds
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "queue-waiting-hint" }, [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(
                                  "\n                  前方有导出任务正在执行，请耐心等待\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "queue-tip" }, [
                                _c("i", {
                                  staticClass: "el-icon-s-management",
                                }),
                                _vm._v(
                                  "\n                  您可以关闭此窗口，前往「导出任务」查看具体排队情况\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "queue-action" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "goto-task-btn",
                                      attrs: { type: "primary", size: "small" },
                                      on: { click: _vm.goToExportTask },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-view" }),
                                      _vm._v(
                                        "\n                    查看导出任务\n                  "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _c("div", [
                              _c("i", {
                                staticClass: "el-icon-download export-icon",
                              }),
                              _vm._v(" "),
                              _c("h3", { staticClass: "export-title" }, [
                                _vm._v("正在导出数据，请稍候..."),
                              ]),
                              _vm._v(" "),
                              _vm.exportConditionText
                                ? _c(
                                    "div",
                                    { staticClass: "export-condition" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "condition-label" },
                                        [_vm._v("本次导出条件：")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "condition-content" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.exportConditionText)
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "progress-container" },
                                [
                                  _vm.exportProgress < 100
                                    ? _c("el-progress", {
                                        attrs: {
                                          percentage: _vm.exportProgress,
                                          "stroke-width": 20,
                                          color: _vm.customColors,
                                          "text-inside": true,
                                        },
                                      })
                                    : _c("el-progress", {
                                        attrs: {
                                          percentage: 100,
                                          "stroke-width": 20,
                                          color: "#67C23A",
                                          status: "success",
                                          "text-inside": true,
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "progress-info" }, [
                                    _c("span", { staticClass: "status-text" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.exportProgress < 100
                                            ? "导出处理中..."
                                            : "导出完成！"
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "progress-text" },
                                      [_vm._v(_vm._s(_vm.exportProgress) + "%")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.exportProgress < 100
                                ? _c("div", { staticClass: "export-tip" }, [
                                    _c("i", { staticClass: "el-icon-info" }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "关闭弹窗后可在「导出任务」中查看进度和下载文件"
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      staticClass: "duplicate-export-dialog",
                      attrs: {
                        title: "已存在相同导出任务",
                        visible: _vm.duplicateExportDialogVisible,
                        width: "520px",
                        "close-on-click-modal": false,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.duplicateExportDialogVisible = $event
                        },
                      },
                    },
                    [
                      _vm.duplicateExportData
                        ? _c(
                            "div",
                            { staticClass: "duplicate-export-content" },
                            [
                              _c(
                                "div",
                                { staticClass: "duplicate-icon-wrapper" },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-document-checked duplicate-icon",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "duplicate-info" }, [
                                _vm.duplicateExportData.message
                                  ? _c("div", { staticClass: "info-main" }, [
                                      _vm._v(
                                        _vm._s(_vm.duplicateExportData.message)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-hint" }, [
                                  _c("i", { staticClass: "el-icon-info" }),
                                  _vm._v(
                                    "\n                  如需使用当前筛选条件重新导出，请点击「重新导出」按钮\n                "
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.duplicateExportData.conditionSummary
                                  ? _c(
                                      "div",
                                      { staticClass: "info-condition" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "info-label" },
                                          [_vm._v("导出条件：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "info-value" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.duplicateExportData
                                                  .conditionSummary
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-time" }, [
                                  _c("span", { staticClass: "info-label" }, [
                                    _vm._v("创建时间："),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "info-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.duplicateExportData.createTime
                                          ? _vm.formatDateTime(
                                              _vm.duplicateExportData.createTime
                                            )
                                          : "-"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "dialog-footer",
                          attrs: { slot: "footer" },
                          slot: "footer",
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.duplicateExportDialogVisible = false
                                },
                              },
                            },
                            [_vm._v("关闭")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "warning" },
                              on: { click: _vm.handleGoToExportTask },
                            },
                            [
                              _c("i", { staticClass: "el-icon-s-management" }),
                              _vm._v(" 导出任务\n              "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "danger" },
                              on: { click: _vm.handleRedoExport },
                            },
                            [
                              _c("i", { staticClass: "el-icon-refresh" }),
                              _vm._v(" 重新导出\n              "),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.handleDuplicateDownload },
                            },
                            [
                              _c("i", { staticClass: "el-icon-download" }),
                              _vm._v(" 立即下载\n              "),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      class: {
                        "el-icon-arrow-down": !_vm.isFormVisible,
                        "el-icon-arrow-up": _vm.isFormVisible,
                      },
                      attrs: { type: "primary" },
                      on: { click: _vm.toggleForm },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.isFormVisible ? "收起" : "展开") +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _vm.listData.list.length > 0
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  key: _vm.tableKey,
                  ref: "orderListRef",
                  staticClass: "table",
                  attrs: {
                    data: _vm.listData.list,
                    size: "mini",
                    height: "70vh",
                    "highlight-current-row": "",
                    "header-cell-style": { fontWeight: "bold" },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderNo",
                      label: "订单编号",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.orderNo))]),
                              _vm._v(" "),
                              scope.row.payNo
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#d10069" } },
                                    [
                                      _c("br"),
                                      _vm._v(
                                        "微信订单号：" + _vm._s(scope.row.payNo)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.TYPE_COLOR_MAP[scope.row.type],
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.typeName))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3400137512
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuName",
                      label: "产品名称",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  [101, 102].includes(scope.row.type)
                                    ? scope.row.spuName
                                    : scope.row.skuName
                                ),
                              },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      1762883101
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      label: "产品编码",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.skuCode),
                              },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      3033558258
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuAttr",
                      label: "销售属性",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.skuAttr),
                              },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      2426467756
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      label: "品牌",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.brandName),
                              },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      2712695566
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplierName",
                      label: "供应商",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.supplierName),
                              },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      157764577
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "订单状态",
                      "min-width": "90",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c("div", {
                              domProps: {
                                innerHTML: _vm._s(scope.row.statusName),
                              },
                            })
                          },
                        },
                      ],
                      null,
                      false,
                      1969585537
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deliveryStatusName",
                      label: "物流状态",
                      "min-width": "90",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "订单标签",
                      "min-width": "140",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _c(
                              "span",
                              {},
                              [
                                scope.row.tagName
                                  ? _c("el-tag", { attrs: { size: "mini" } }, [
                                      _vm._v(_vm._s(scope.row.tagName)),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.tagRemark,
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ellipsis2",
                                        staticStyle: { width: "130px" },
                                      },
                                      [_vm._v(_vm._s(scope.row.tagRemark))]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      1593272488
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userRemark",
                      label: "客户备注",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalQuantity",
                      label: "产品数量",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "orderPrice",
                      label: "订单金额",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.orderPrice)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2690960837
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "paidPrice",
                      label: "实付金额",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.paidPrice))]),
                              _vm._v(" "),
                              scope.row.paidPrice > 0 && scope.row.payChannel
                                ? _c("span", [
                                    _c("br"),
                                    _vm._v(
                                      "支付方式：" +
                                        _vm._s(scope.row.payChannel)
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1023376016
                    ),
                  }),
                  _vm._v(">\n        "),
                  !_vm.ljcType && this.userType !== 5
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "supplierCost",
                          label: "平台成本价",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerCost",
                      label: _vm.isAgentOrMiniApp ? "客户供货价" : "客户成本价",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.customerCost)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2718353737
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "couponId",
                      label: "关联卡券ID",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "useIntegral",
                      label: "福豆消耗",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "receiverName",
                      label: "收件人",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deliveryNo",
                      label: "物流单号",
                      "min-width": "140",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "140",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipmentsTime",
                      label: "发货时间",
                      "min-width": "140",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "updateTime",
                      label: "最后更新时间",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _vm.userType == 1
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "sourceType",
                          label: "销售渠道",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userType == 1
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "customerOrderName",
                          label: "归属项目",
                          "min-width": "100",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "companyName",
                      label: "员工企业",
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "paymentMerchantType",
                      label: "收款商户类型",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    scope.row.paymentMerchantType === 0
                                      ? "平台"
                                      : scope.row.paymentMerchantType === 1
                                      ? "商家"
                                      : "-"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1256314979
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "merchantNo",
                      label: "收款商户号",
                      "min-width": "140",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      "min-width": "180",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["admin:order:detail"],
                                      expression: "['admin:order:detail']",
                                    },
                                  ],
                                  staticClass: "mr10",
                                  attrs: { size: "small", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openOrderDetail(
                                        scope.row.orderNo
                                      )
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              _vm._v(" "),
                              ![99].includes(scope.row.type)
                                ? _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "has-permi",
                                          rawName: "v-has-permi",
                                          value: ["admin:order:do:tag"],
                                          expression: "['admin:order:do:tag']",
                                        },
                                      ],
                                      staticClass: "mr10",
                                      attrs: { size: "small", type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.orderBindTag(
                                            scope.row.orderNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("打标")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isCouponGoodsOrder(scope.row)
                                ? [
                                    scope.row.status > 1 &&
                                    ![99].includes(scope.row.type) &&
                                    !_vm.isLuckyWheelGiftOrder(scope.row)
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "mr10",
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handerAftersale(0, {
                                                  orderNo: scope.row.orderNo,
                                                })
                                              },
                                            },
                                          },
                                          [_vm._v("创建售后")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    [2, 3, 4, 5, 16].includes(
                                      scope.row.status
                                    ) && ![99].includes(scope.row.type)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:order:to:shipment",
                                                ],
                                                expression:
                                                  "['admin:order:to:shipment']",
                                              },
                                            ],
                                            staticClass: "mr10",
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.sendOrder(
                                                  scope.row.orderNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("订单发货")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    [1, 2].includes(scope.row.status) &&
                                    ![99].includes(scope.row.type)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:order:update:receive",
                                                ],
                                                expression:
                                                  "['admin:order:update:receive']",
                                              },
                                            ],
                                            staticClass: "mr10",
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateReceive(
                                                  scope.row.orderNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("修改地址")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.status == 1 &&
                                    scope.row.useIntegral &&
                                    scope.row.useIntegral == 0 &&
                                    ![99].includes(scope.row.type)
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:order:update:price",
                                                ],
                                                expression:
                                                  "['admin:order:update:price']",
                                              },
                                            ],
                                            staticClass: "mr10",
                                            attrs: {
                                              size: "small",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updatePrice(
                                                  scope.row.orderNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("订单改价")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isLuckyWheelGiftOrder(scope.row) &&
                                    (([2].includes(scope.row.status) &&
                                      ![5, 99].includes(scope.row.type)) ||
                                      ([6].includes(scope.row.status) &&
                                        scope.row.type == 110))
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: ["admin:order:cancel"],
                                                expression:
                                                  "['admin:order:cancel']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.cancelUserOrder(
                                                  scope.row.orderNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("取消订单")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.authMsg && scope.row.type != 99
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "admin:message:send-notification",
                                                ],
                                                expression:
                                                  "['admin:message:send-notification']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.sendMessage(
                                                  scope.row.orderNo,
                                                  scope.row.spuName,
                                                  scope.row.tagRemark
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("发送消息")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == 12 &&
                                    scope.row.status == 2
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.bindOrderKami(
                                                  scope.row.orderNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("卡券绑定")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.type == 12
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.sendOrderKami(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("卡密发送")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    [1, 8].includes(scope.row.type) &&
                                    [2, 3].includes(scope.row.status)
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handelStatusPopup(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("状态修改")]
                                        )
                                      : _vm._e(),
                                  ]
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1518048462
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ImportTransport", {
        ref: "ImportTransportRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("ImportFudouStatus", {
        ref: "ImportFudouStatusRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("OrderDetail", { ref: "OrderDetailRef" }),
      _vm._v(" "),
      _c("BindTag", {
        ref: "BindTagRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("OrderSend", {
        ref: "OrderSendRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("CancelOrder", {
        ref: "CancelOrderRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("ChangeReceive", {
        ref: "ChangeReceiveRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("ChangePrice", {
        ref: "ChangePriceRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("SendMsg", {
        ref: "SendMsgRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("SendKami", {
        ref: "SendKamiRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
      _vm._v(" "),
      _c("OrderStatusPopup", {
        ref: "OrderStatusPopupRef",
        on: {
          doRefresh: function ($event) {
            return _vm.handerSearch(0)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }